<template>
<div class="chapter">
<div class="inner_page">
<p class="block_11" id="calibre_pb_3"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_13">For my Nonna, Maria Preziosi<br class="calibre1"/> For my Papa, Dante Preziosi<br class="calibre1"/> For my Zio, Anthony Preziosi<br class="calibre1"/>&amp;<br class="calibre1"/>my Zio, Mario Preziosi<br class="calibre1"/><br class="calibre1"/>You are forever carved into my memory.</p>
<p class="block_14"> </p>
<p class="block_15"><br class="calibre1"/> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?0609197b